// extracted by mini-css-extract-plugin
export var container = "styles-module--container--07ff0";
export var heading = "styles-module--heading--79142";
export var sidebarSection = "styles-module--sidebarSection--08659";